import React from "react";

export default function FieldMultiselect_InlineValueNotEmpty(props:any) {

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default", "ui5-field-dropdown-inline-editable", "max-w-300", "fl-wrap", "m-t-4", "m-b-4", props.className)} onClick={props.onClick}>
                {_.map(props.options, option => {
                    return <props.field.components.Pill key={option.value} className="m-r-10 m-t-4 m-b-4" option={option} onDelete={props.onDelete}/>
                })}
            </div>
            {props.children}
        </React.Fragment>
    );
}